import { useCallback } from "react";
import appConst from "../Utilities/appConst.json";
import { basketActions, updateBasketItemQuantity } from "../store/basket";
import { modeActions } from "../store/modeSlice";

/**
 * Shared helpers for basket items.
 * - setCountValue: quantity updater (requires dispatch + item)
 * - handleChange: checkbox/onToggle handler (uses props)
 * - getImageUrl: image URL fallback (uses props)
 */
const useBasketItemHelpers = (configOrDispatch, maybeItem) => {
  const isLegacy = typeof configOrDispatch === "function";

  const dispatch = isLegacy ? configOrDispatch : configOrDispatch?.dispatch;
  const item = isLegacy ? maybeItem : configOrDispatch?.item;
  const props = isLegacy ? null : configOrDispatch?.props;

  const setCountValue = useCallback(
    (count) => {
      if (!dispatch || !item) return;
      const validatedCount = Math.max(1, Math.floor(Number(count) || 1));
      dispatch(modeActions.setValueGA4({ value: appConst.number_of_copies }));
      dispatch(
        basketActions.setBasketItemsQuantity({
          value: validatedCount,
          index: item.item_id,
        })
      );
      dispatch(updateBasketItemQuantity(validatedCount, item));
    },
    [dispatch, item]
  );

  const handleChange = useCallback(
    (checked) => {
      const nextChecked =
        typeof checked === "boolean" ? checked : !props?.isChecked;
      if (props?.setSelectedValue) {
        props.setSelectedValue(nextChecked, props.id);
      }
    },
    [props?.id, props?.isChecked, props?.setSelectedValue]
  );

  const getImageUrl = useCallback(() => {
    return props?.item?.itemImageUrl || props?.item?.url || null;
  }, [props?.item?.itemImageUrl, props?.item?.url]);

  return { setCountValue, handleChange, getImageUrl };
};

export default useBasketItemHelpers;
